import { useEffect } from 'react';
import { transferToNative } from "@src/lib/WebAppBridge";

const StoreRedirect = () => {
  useEffect(() => {
    transferToNative('', 'onRedirectStore');
  }, []);

  return null;
};

export default StoreRedirect;